module.exports = __webpack_public_path__ + "static/img/page1-fav.cd9fa441.png";